import { Link, withPrefix } from "gatsby"
import React from "react"

import siteTop from "../../images/siteTop.jpg"
import epa from "../../images/epa.png"
import siteProblem from "../../images/site-problem.jpg"
import siteFact1 from "../../images/site-fact1.jpg"
import siteFact2 from "../../images/site-fact2.jpg"


import "./site.scss"

const SiteComponent = () => (
  <section className="section site">
    <h1 className="sectionTitle">US Navy Toxic Waste Site</h1>
    <h3 className="sectionSubtitle">3200 East Foothill Blvd, Pasadena</h3>
    <div className="imageWrapper titleImageWrapper">
      <img className="titleImage" src={siteTop} alt="waste site"/>
    </div>
    <div className="pageNav">
      <ul>
        <Link to="/site/#background+problem"><li>Background & Problem</li></Link>
        <Link to="/site/#solution"><li>Our Solution</li></Link>
        <Link to="/site/#scientists"><li>What Top Medical Scientists Say</li></Link>
        <Link to="/site/#publications"><li>Scientific Publications on Site Risks</li></Link>
        <Link to="/site/#faq"><li>FAQ</li></Link>
        <Link to="/site/#fact-sheet"><li>Fact Sheet and References</li></Link>
        <Link to="/site/#developer-mislead"><li>Did the Developer Misrepresent Risks?</li></Link>
      </ul>
    </div>
    <div className="subsectionWrapper grey">
      <div className="subsection background" id="background+problem">
        <h2 className="subsectionTitle">Background & Problem</h2>
        <div className="textBlock">
          <p>
            From World War II until 1974, the US Naval Ordinance Testing Station, Pasadena, developed, tested, and manufactured Navy weapons, especially torpedoes and Polaris (nuclear) missiles in 27 buildings. It did secret, classified experiments on explosives, propellants, new weapons, perfluoroalkyl (PFAS) flame retardants, and many unknown materials&mdash;then dumped toxins directly into the soil via floor drains, cesspools, and sumps. Instead of cleanup, in 1978 the Navy asphalted anything not covered by buildings, then sold the property to Space Bank (a storage/rental facility). It fought regulators and did no cleanup, though the law requires remediation according to Superfund rules. Instead Space Bank has rented hundreds of units, in risky World War II buildings, for self storage and to scores of small, one-man businesses, such as awning-makers, furniture-makers, auto repairmen, and iron workers.
          </p>
          <p>
            Prospective buyers repeatedly stopped purchase plans, after confirming major contamination, including industrial solvents, heavy metals, PCBs, dioxins, and petroleum products from subsurface storage tanks. Carcinogenic solvents carbon tetrachloride (CT), perchloroethylene (PCE), and trichloroethylene (TCE) are widespread, the highest site risks, with concentrations nearly a million times above allowed levels.
          </p>
          <p>
            In 2019 CA Dept. of Toxic Substances Control (DTSC) somehow approved the plans of Trammell Crow, the largest US commercial developer (assets of $65 billion), to build 550 apartments onsite (now called the Naval Information Research Foundation). Yet safety problems and data gaps remain, risking the health of current/future renters and residents, including many low-income families.  <u>First</u>, DTSC required cleanup of only 11 small metals hotspots&mdash;not cleanup of carcinogenic "risk drivers", CT, PCE, and TCE. <u>Second</u>, because Space Bank allowed no full access, groundwater/indoor air/contaminant migration has never been tested, despite carcinogenic vapor intrusion risks from solvents like TCE that have no safe dose, cause birth defects, and can irreversibly damage multiple body systems including the brain, heart, immune system, kidneys, and liver. <u>Third</u>, no sampling has been done for likely carcinogens RDX and TNT, the propellants/explosives used in 70% of weapons made at NOTSPA. RDX and TNT can cause blood, brain, gastrointestinal, heart, kidney, liver and lung damage. <u>Fourth</u>, no testing has been done for likely carcinogenic PFAS that can cause developmental, immune, kidney, liver, lung and reproductive defects.
          </p>
          <p>
            In response to Trammell Crow's risky and inadequate Removal Action Workplan, in 2019 the nonprofit charity, Stop Toxic Housing in Pasadena (STHIP) sued DTSC, to seek immediate site testing and cleanup. (Space Bank and Trammell Crow are defendants/interested parties.) STHIP is showing that testing and proposed mitigation violate the requirements of the federal Comprehensive Environmental Response, Compensation, and Liability Act (CERCLA), National Contingency Plan (NCP), the California Environmental Quality Act (CEQA), and other laws. The case is still being tried in court.
          </p>
        </div>
      </div>
    </div>
    <div className="subsectionWrapper">
      <div className="subsection solution" id="solution">
        <h2 className="subsectionTitle">Our Solution</h2>
        <div className="textBlock">
          <p><a href="http://chng.it/kdFmfDLFmC">Please Sign Our Online Petition Today</a></p>
          <p>The petition says that “We call on California Dept. of Toxic Substances Control to require  full  site  testing  and cleanup of the  military toxic-waste site at 3200 E. Foothill Blvd, Pasadena, <b>BEFORE</b> allowing any site construction.”</p>
        </div>
      </div>
    </div>
    <div className="subsectionWrapper grey">
      <div className="subsection scientists" id="scientists">
        <h2 className="subsectionTitle">What Top Medical Scientists Say</h2>
        <div className="scientist-declaration">
          <h4>Medical Scientists' Declaration, 1-16-2020</h4>
          <h3>"The only way to guarantee full public-health protection, especially protection of children from solvents like TCE, is to require full site testing and cleanup before any construction on the former US Naval Ordinance Test Station, Pasadena, California."</h3>
          <div className="sources">

          <p>
            <b>Dr. David Bellinger (PhD)</b>, Department of Neurology, Harvard Medical School and Boston Children's Hospital, Cambridge, Massachusetts
          </p>
          <p>
          <b>Dr. Maryse Bouchard (PhD)</b>, Department of Environmental and Occupational Health, University of Montréal, and the University Hospital Center Sainte-Justine (largest Canadian mother-and-child medical center in Canada)
          </p>
          <p>
          <b>Dr. Thomas Burke (PhD, MPH)</b>, Jacob I and Irene B. Fabrikant Chair, Health Risk and Society, Bloomberg School of Public Health, Johns Hopkins University, Baltimore, MD
          </p>
          <p>
            <b>Dr. Jane Caldwell (PhD)</b>, Senior Toxicologist for 25 years (until 2016) in the US Environmental Protection Agency, Washington, DC
          </p>
          <p>
            <b>Dr. Devra Davis (PhD, MPH)</b>, Visiting Professor of Medicine, Hebrew University, Jerusalem and Fellow, American College of Epidemiology
          </p>
          <p>
            <b>Dr. I. De Melo-Martin (PhD)</b>, Departments of Medicine and Reproductive Medicine, Weill Medical College of Cornell University, NY, NY
          </p>
          <p>
            <b>Dr. Ken Filchak (PhD)</b>, Department of Biological Sciences, University of Notre Dame, South Bend, Indiana
          </p>
          <p>
            <b>Dr. Adam Finkel (ScD, CIH)</b>, Department of Environmental Health Sciences, School of Public Health, University of Michigan, Ann Arbor, Michigan
          </p>
          <p>
            <b>Dr. Jill Johnston (PhD)</b>, Department of Preventive Medicine, Division of Environmental Health, Keck School of Medicine, University of Southern California, Los Angeles, California
          </p>
          <p>
            <b>Dr. Samantha Knowlton (MD, MS)</b>, Department of Medicine and Clinical and Translational Science Center, Weill Medical College of Cornell University, NY, NY
          </p>
          <p>
            <b>Dr. Charles Kulpa (PhD)</b>, Department of Biological Sciences, University of Notre Dame, South Bend, Indiana
          </p>
          <p>
            <b>Dr. Bruce Lanphear (MD, MPH)</b>, Health Sciences, Simon Fraser University, Vancouver, BC, Canada
          </p>
          <p>
            <b>Dr. David Michaels (PhD, MPH)</b>, Department of Environmental and Occupational Health, Milken Institute School of Public Health, George Washington University, Washington, DC
          </p>
          <p>
            <b>Dr. Celeste Monforton (DrPH, MPH)</b>, Milken Institute School of Public Health, George Washington University, Washington, DC, and Fellow, Collegium Ramazzini, Bologna Italy
          </p>
          <p>
            <b>Dr. Colleen Moore (PhD)</b>, Department of Psychology, University of Wisconsin, Madison, Wisconsin
          </p>
          <p>
            <b>Dr. David Ozonoff (MD, MPH)</b>, Department of Sociomedical Sciences, School of Medicine, and Department of Environmental Health, School of Public Health, Boston University, Boston, Massachusetts
          </p>
          <p>
            <b>Dr. Beate Ritz (MD, PhD)</b>, Department of Neurology, School of Medicine, and Departments of Epidemiology and Environmental Health Sciences, School of Public Health, UCLA, Los Angeles
          </p>
          <p>
            <b>Dr. Anthony Serianni (PhD)</b>, Department of Chemistry and Biochemistry, University of Notre Dame, South Bend, Indiana
          </p>
          <p>
            <b>Dr. Kristin Shrader-Frechette (PhD)</b>, O'Neill Family Professor Emerita, Department of Biological Sciences & Philosophy of Science PhD Program, University of Notre Dame, South Bend, IN
          </p>
          <p>
            <b>Dr. Veena Singla (PhD)</b>, Department of Obstetrics, Gynecology, and Reproductive Sciences, School of Medicine, University of California, San Francisco
          </p>
          <p>
            <b>Dr. Donald Smith (PhD)</b>, Microbiology and Environmental Toxicology Department, University of California, Santa Cruz
          </p>
          <p>
            <b>Dr. Roberta White (PhD, ABPP)</b>, Department of Neurology, School of Medicine, and Department of Environmental Health, School of Public Health, Boston University, Boston
          </p>
          <p>
            <b>Dr. Tracey Woodruff (PhD, MPH)</b>, Department of Obstetrics, Gynecology, and Reproductive Sciences, School of Medicine, University of California, San Francisco
          </p>
          </div>
        </div>
        <div className="imageWrapper centered">
          <img src={epa} alt="california state water board logo"/>
        </div>
        <div className="textBlock">
          <div className="waterBoardQuote">
            <ol>
              <li>"From our experience at other cleanup sites, the most thorough and best way to handle a site, of this type, is for site cleanup work and supervision of work to be conducted by an independent party."</li>
              <li>"It's easier and cheaper to clean up the site now rather than later, after construction." </li>
            </ol>
            <p className="rightAligned">Anthony C. Zampiello, Executive Officer and Main San Gabriel and Main Raymond Water Basins Watermaster </p>
          </div>
          <p>However, contrary to the watermaster’s expert experience (1) above , Pasadena city council is allowing the developer---who has a clear financial conflict of interest---to test and clean-up the toxic-waste site from which the developer stands to make significant amounts of money.</p>
          <p>Similarly, contrary to the watermaster’s expert experience (2) above, Pasadena city council is allowing the developer to try to test and cleanup the site after construction.</p>
        </div>
      </div>
    </div>
    <div className="subsectionWrapper">
      <div className="subsection publications" id="publications">
        <h2 className="subsectionTitle">Scientific Publications on Site Risks</h2>
        <div className="textBlock">
          <div className="articleBlock">
            <p>
              An article in a top US science journal (housed at U of Maryland Medical School, with editors from the US National Institutes of Health) says developer Trammell Crow's Pasadena-site, risk-assessment studies&mdash;submitted to state regulators&mdash;commit potential scientific fraud; underestimate site risks by at least a factor of 10,000; <b>fail</b> standard, scientific <b>data-audit</b> tests; and violate US and CAL EPA cleanup standards.
            </p>
            <a href="https://www.tandfonline.com/doi/full/10.1080/08989621.2019.1695200">View This Scientific Article</a>
          </div>
          <div className="articleBlock">
            <p>
              Another article in a top US science journal (with Harvard and Stanford medical-school and Johns Hopkins editors) says the developer Trammell Crow's Pasadena site studies <b>fail</b> standard, scientific <b>data-quality</b> tests, show bias, ignore harm, violate US and CAL EPA cleanup rules, and put children at the highest risk.
            </p>
            <a href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7014154">View This Scientific Article</a>
          </div>
          <div className="articleBlock">
            <p>
              One of the top US hydrogeochemists&mdash;who for decades has cleaned up US Navy toxic sites like this one in Pasadena&mdash;is an expert on remediating carcinogenic, industrial-solvent wastes that migrate into indoor air. He says that developer Trammell Crow's Pasadena developer's site testing and proposed remediation methods "do not sufficiently comply with" US EPA cleanup requirements, can "understate the actual exposure risk" to victims, and do not provide "accurate estimates" of humans' Reasonable Maximum Exposure to site carcinogens. His statement includes links to several of his many publications.
            </p>
            <a href="https://drive.google.com/open?id=1cpaqK46HJWkLKZH_GdPHYsS2tjg47ZiC">View This Scientific Statement and Articles</a>
          </div>
        </div>
      </div>
    </div>
    <div className="subsectionWrapper grey">
      <div className="subsection faq" id="faq">
        <h2 className="subsectionTitle">Frequently Asked Questions</h2>
        <div className="pdfLink">
          <a href={withPrefix('/site-faq.pdf')} target="blank">View Full FAQ Document</a>
        </div>
        <div className="textBlock faq">
          <ol>
            <li>
              <h3 className="faqQuestion">WHY ARE CITIZENS CONCERNED?</h3>
              <p className="faqAnswer">
                Without requiring full site testing/cleanup, the city approved building 550 apartments, designed for <b>hundreds of children</b>, on
                a toxic-waste site. After this partial testing/cleanup, the developer admits groundwater contamination &amp; cancer risk will remain
                “<b>unknown</b>.” Despite these key “unknowns,” CA Toxic Substances Control claims the project is one “where clearly no significant
                effects would occur,” yet approved <b>land-use controls</b> (prohibiting exposure to site soil/water). It gave the developer <b>protection
                from liability</b> for site toxins, for doing only quick, inexpensive removal of 12 suspected “hot spots,” many never even tested.
              </p>
            </li>
            <li>
              <h3 className="faqQuestion">WHAT'S OUR SOLUTION?</h3>
              <p className="faqAnswer">
                Before development, we want <b>full site testing/cleanup</b>&mdash;which the developer says costs $1-2 million more than partial cleanup.
              </p>
            </li>
            <li>
              <h3 className="faqQuestion">HOW WAS THIS TOXIC SITE USED BY THE US NAVY?</h3>
              <p className="faqAnswer">
                For 30 years the Navy did <b>secret testing &amp; manufacturing of Polaris missiles</b>, torpedoes, &amp; propellants. The site had a
                foundry, 5 incinerators, combustion labs, large torpedo-test water tanks, &amp; 2 rail lines to receive materials &amp; ship out weapons.
              </p>
            </li>
            <li>
              <h3 className="faqQuestion">WHAT TOXINS ARE ONSITE?</h3>
              <p className="faqAnswer">
                The site has carcinogens, neurotoxins, mutagens, &amp; developmental toxins having <b>no safe dose</b>. These include arsenic; dioxins
                &amp; furans; lead; mercury; PAHs; PCBs; explosives &amp; propellants like RDX; radioactive materials; &amp; carcinogenic VOCs.
              </p>
            </li>
            <li>
              <h3 className="faqQuestion">HOW DANGEROUS IS THE SITE?</h3>
              <p className="faqAnswer">
                Site assessments say site <b>cancer risks</b> are up to <b>8,300 times above</b> what regulations allow. CA Toxic Substances Control
                called the site an <b>“imminent and substantial” danger</b>, yet claims its health risks will not be “significant,” after partial cleanup.
              </p>
            </li>
            <li>
              <h3 className="faqQuestion">HOW GOOD ARE SITE STUDIES&mdash;USED BY THE DEVELOPER & THE CITY?</h3>
              <p className="faqAnswer">
                Of 20 site studies, all 20 are incomplete, 3 are potentially fraudulent, &amp; 17 fail to pass US EPA data-validation (anti-fraud) tests.
                3 site studies were done by contractors who were fined nearly $ 1 billion&mdash;for <b>repeated fraud</b> at other US toxic-site cleanups.
              </p>
            </li>
            <li>
              <h3 className="faqQuestion">WHY IS ADDITIONAL SITE TESTING & SAMPLING NEEDED?</h3>
              <p className="faqAnswer">
                Site contaminants forced 2 Pasadena drinking-water wells to close, but groundwater, full soil, &amp; many suspected hot-spots have
                <b> never been tested</b>. No tests have been done for perfluoroalkyls&mdash;&amp; propellants &amp; explosives HBX, RDX, &amp; TNT, the main ingredients
                in 71% of weapons made onsite. Without full, preconstruction testing/cleanup, residents face years of cancer exposures.
              </p>
            </li>
            <li>
              <h3 className="faqQuestion">WHAT'S WRONG WITH LETTING THE DEVELOPER DO PARTIAL SITE CLEANUP?</h3>
              <p className="faqAnswer">
                The developer says carcinogens (with no safe dose) will be “left in place,” as full cleanup would be “costly and time-intensive.”
                He also says it’s “outside” his “obligations” to show that carcinogens, “left in place” won’t be a “<b>future threat</b>,” but admits that
                doing cleanup, after construction, will cause residents years of <b>higher cancer risks</b>. The developer has a conflict of interest.
              </p>
            </li>
            <li>
              <h3 className="faqQuestion">HOW DO UNBIASED STATE EXPERTS WANT TO HANDLE THE SITE TESTING & CLEANUP?</h3>
              <p className="faqAnswer">
                Raymond &amp; San Gabriel Basins Watermaster (CA Water Board), Anthony Zampiello says: &quot;It&#39;s <b>easier &amp; cheaper to clean up
                the site now</b> rather than later, after construction. From our experience at other cleanup sites, the most thorough &amp; best way,
                to handle a site of this type, is for site-cleanup work and supervision of work to be conducted by an <b>independent party</b>.&quot;
              </p>
            </li>
            <li>
              <h3 className="faqQuestion">WHY WON'T REMOVING SUSPECTED HOT SPOTS REMOVE "SOURCES" OF SITE TOXINS?</h3>
              <p className="faqAnswer">
                The developer must remove only 12 small, suspected hot spots, yet site carcinogens are “<b>uniformly distributed</b>.” Unless all
                cancer “sources” are removed from soil &amp; water, they will harm future residents, soil, &amp; groundwater. Given no groundwater,
                deeper-soil, full-hotspot, &amp; RDX testing, all site <b>contaminants aren’t known &amp; located</b>&mdash;so their “sources” can’t be removed.
              </p>
            </li>
            <li>
              <h3 className="faqQuestion">WHY IS SITE TESTING FOR RDX NEEDED?</h3>
              <p className="faqAnswer">
                The official list of contaminants is incomplete. It includes neither flame-retardants, perfluoroalkyls, nor HBX, RDX, &amp; TNT&mdash;
                explosives and propellants used onsite in 71% of weapons known to have been tested &amp; manufactured onsite. CA regulates
                perfluoroalkyls, as well as HBX, RDX, &amp; TNT, as they already have caused much <b>cancer</b>, central-nervous-system and
                immune damage, plus <b>developmental harm to children</b> at other US military toxic sites in California.
              </p>
            </li>
            <li>
              <h3 className="faqQuestion">IS IT SAFE FOR CHILDREN TO LIVE ON THIS TOXIC-WASTE SITE?</h3>
              <p className="faqAnswer">
                CA Toxic Substances Control called this site, <b>an “imminent &amp; substantial” danger</b>. It will house hundreds of children, plus
                preschoolers. When adults &amp; children face the same toxic exposure, US EPA warns <b>harm to children is 10 times worse</b>, as
                they are developing, have limited toxics &amp; immune-system protections, &amp; take in proportionately more air/water/pollution than
                adults. Site assessors did no child-risk assessment, contrary to US EPA &amp; National Academy of Sciences recommendations.
              </p>
            </li>
          </ol>
        </div>
      </div>
    </div>
    <div className="subsectionWrapper">
      <div className="subsection factSheet" id="fact-sheet">
        <h2 className="subsectionTitle">Fact Sheet and References</h2>
        <div className="pdfLink">
          <a href={withPrefix('/waste-site-fact-sheet.pdf')}>View Full Fact Sheet &amp; References</a>
        </div>
        <div className="imageWrapper centered">
          <img src={siteFact2} alt="military building"/>
        </div>
        <div className="textBlock">
          <p>In LA County <b>570,000 residents</b> qualify for affordable housing but can’t find any.</p>
          <p>
          California Toxic Substances Control said this site was an <b>“imminent and substantial”
          danger</b>, and current site cancer risks are up to 8,300 times higher than allowed.
          </p>
          <p>
            California Department of Toxic Substances Control claims that after the partial site
            cleanup, although site residents’ cancer risk will be “unknown,” nevertheless site health
            impacts are “not significant.”
          </p>
          <p>
            The city is allowing many <b>site carcinogens to remain “in place,”</b> as they are below
            ground. It admits that site groundwater-contamination is “unknown”; that many soil
            areas have never been sampled; and that not all “sources” of site carcinogens,
            metals, dioxins, solvents, and propellants have been located. The city is requiring <b>no
            groundwater or full soil-carcinogen testing</b> before construction, though site toxins
            have already contaminated and closed two adjacent Pasadena drinking-water wells.
          </p>
          <p>
            The site has <b>never been tested</b> (&amp; no tests are required) for the neurotoxic and
            carcinogenic <b>perfluoroalkyls</b> (military flame-retardants), and for RDX &amp; TNT
            (explosives/propellants). Yet California has regulations for perfluoroalkyls, RDX &amp;
            TNT, and 71% of weapons manufactured &amp; tested at this site <b>contained RDX &amp; TNT</b> in
            warheads, in propellants, or in both.
          </p>
          <p>
            The developer has promised to “<b>safely clean up</b>” the site and provide “affordable
            housing.” The city says the project would preserve air quality and safety.
          </p>
          <div className="imageWrapper centered">
            <img src={siteFact1} alt="military building"/>
          </div>
          <p>
            In 2011 the developer signed an agreement with the state. It gives the <b>developer liability
            protection</b> from site toxins, in exchange for his inexpensively removing 12 suspected
             “hot spots.” Instead of full cleanup, the agreement allows site <b>land-use restrictions</b>
            (prohibiting exposure to site soil or water) to ensure residents “full protection.”
          </p>
          <p>
            State water-protection authorities say that &quot;from our experience at other cleanup sites,
            the most thorough and best way to handle a site of this type&mdash;is for site cleanup work
            and supervision of work to be conducted by an <b>independent party</b>. It&#39;s easier and
            cheaper to <b>clean up the site now</b> rather than later, after construction.&quot;
          </p>
          <p>
            When California Toxic Substances Control asked the developer for evidence that soil
            <b> carcinogens</b>, “left in place….will not be a <b>future threat</b>,” the developer responded that
            providing such testing and evidence “is outside the…obligations” of his company.
          </p>
          <p>
            The developer also said that site “remedial decisions can be made” by using studies
            that don’t meet required US EPA data-validation (anti-fraud) requirements.
          </p>
          <p>
            However, the developer said “numerous site investigations,” including in 2007 by the
            developer’s consultant, show the site will be “<b>safe for occupancy</b>.”
          </p>
          <p>
            The city and developer claim site safety, based on 20 older studies. Yet all <b>20 studies </b>
            are incomplete, <b>17 studies</b> do not meet US EPA data-validation (anti-fraud)
            requirements, and 3 studies were done by SAIC and Tetra Tech who <b>admitted
            repeated fraud</b> at other toxic-waste clean-ups. Together they have paid nearly $1
            billion in fines. Owners of homes, built on a San Francisco US Navy toxic-waste site,
            are suing Tetra Tech for $27 billion and claiming harm from its fraudulent clean-up.
          </p>
        </div>
      </div>
    <div className="subsectionWrapper grey">
      <div className="subsection developerMislead" id="developer-mislead">
        <h2 className="subsectionTitle">Did the Developer Misrepresent Risks?</h2>
        <div className="pdfLink">
          <a href={withPrefix('/developer-mislead-city.pdf')}>View Full Sheet with Notes</a>
        </div>
        <div className="textBlock">
          <p>
            In 2018 City Council approved the “Pasadena Gateway” project on an un-remediated US
            Navy toxic-waste site, as the city needs affordable housing, and the developer repeatedly
            and publicly promised to “<b>safely clean up the site</b>.” Given his promises, city officials
            also repeatedly promised that the “site will be cleaned up.” On <b>3-8-19</b>, DTSC released its
            CEQA Findings and the developer’s Removal Action Work Plan (RAW). The documents
            have led to <b>new information</b> that now requires investigation, thus re-opening the CEQA
            process. They also suggest the developer may have <b>misled the city</b> about project safety.
          </p>
          <ol>
            <li>
              There is <b>new information</b> that <b>the site was never tested for RDX or TNT</b>, potent
              neurotoxins and carcinogens. RDX and TNT are regulated by the state, the main
              ingredients in 71% of weapons manufactured onsite&mdash;weapons listed in the RAW
              <b> released 3-18-19</b>.
            </li>
            <li>
              There is <b>new information</b> that the site was never tested for perfluoralkyls, fire
              retardants used at 660 US military sites. CA has regulations for perfluoralkyls, as they
              are associated with <b>cancer, neurodevelopmental harm to children</b>, and
              <b> cardiovascular disease</b>.
            </li>
            <li>
              There is <b>new information</b> that state experts disagree with Pasadena’s partial, post-construction,
               toxic-site-cleanup plan. On <b>3-13-19</b> Anthony Zampiello, the Watermaster
              for the San Gabriel and Raymond Basins, said: &quot;From our experience at other cleanup
              sites, the most thorough and best way to handle a site&mdash;of this type&mdash;is for site-cleanup
              work and supervision of work to be conducted by an <b>independent party</b>. It&#39;s easier and
              cheaper to <b>clean up the site now</b> rather than later, after construction.&quot;
            </li>
            <li>
              In the developer’s RAW, <b>released 3-8-19</b>, the developer admits that “it is <b>unknown”
              whether site carcinogens</b> “will continue to present” health threats to residents,
              despite his earlier safety promises, because most site carcinogens will be “left in
              place.”
            </li>
            <li>
              Based on the developer’s promises, city officials said on July 9, 2018 that the
              developer would do “excavation of all contaminated soil onsite.” Now the developer
              says most site <b>carcinogens will be “left in place;”</b> only several suspected hotspots will
              be excavated.
            </li>
            <li>
              In the developer’s RAW, <b>released 3-8-19</b>, the developer admits that because he is
              doing only partial, post-construction testing/cleanup, instead of full, pre-construction
              testing/cleanup, therefore site residents could be exposed to <b>increased cancer risks
              “for more than a year,”</b> until site carcinogens are removed.
            </li>
            <li>
              Despite the developer’s safety promises, his RAW, <b>released 3-8-19</b>, now admits that he
              <b> wants partial (not full) cleanup, as it costs $1-2 million less</b> (half the cost of full
              cleanup). He says partial cleanup takes “three months,” and “due to this extremely tight
              development schedule,” the developer “favors remedial alternatives that can be performed
              quickly.” Yet the city told citizens that they would be safe&mdash;not that they would face
              higher cancer risks in order to save the developer $1-2 million because he is not doing full
              cleanup.
            </li>
            <li>
              Despite his safety promises to the city, the developer’s RAW, <b>released 3-8-19</b>, gives his
              cleanup plan, and it includes <b>land-use controls</b>, eg. prohibiting human contact with site
              soil instead of his spending $1-2 million more for full site cleanup and protection of
              residents. The developer also signed agreements with DTSC that give him (a) rights to use
              <b> land-use controls</b> onsite and (b) <b>protection from DTSC liability</b> for site toxins, in
              exchange for doing only partial site testing/cleanup. Yet safe, cleaned-up sites never
              need land-use controls.
            </li>
            <li>
              Despite his safety promises to the city, the developer gave a questionable answer
              when DTSC asked him for <b>“evidence that site carcinogens, “left in place….will not
              be a future threat”</b> to site residents. The developer responded that providing such
              safety evidence “is outside the…obligations of Pasadena Gateway.”
            </li>
            <li>
              Despite safety promises, the developer’s RAW, <b>released 3-8-19</b>, admits he will do
              no preconstruction groundwater testing, though <b>groundwater contamination</b> is
              “unknown.” Yet site toxins caused city drinking-water wells to close, both East and West
              of the site.
            </li>
            <li>
              Despite safety promises, the developer’s RAW, <b>released 3-8-19</b>, admits the site has
              had <b>no full soil sampling</b>, not even <b>of all suspected hotspots</b>. Toxins can’t be
              “safely cleaned up,” as the developer claims, when testing hasn’t located where all of
              them are.
            </li>
            <li>
              Despite safety promises, the developer’s RAW, <b>released 3-8-19</b>, <b>admits</b> full
              soil/water testing won’t be done before construction. This means the developer hasn’t
              found (thus can’t remove) all site-contaminant “sources.” Thus, in future, <b>soil
              carcinogens will continue polluting soil/water</b>. One can’t remove soil-toxin “sources,”
              that have buildings on them&mdash;just as dentists can’t remove abscesses that have fillings
              or crowns on them.
            </li>
            <li>
              Despite his safety promises, <b>the developer cannot safely clean up the site </b>
              because he is not doing what DTSC documents recommend: “undertake” his “own due
              diligence” by full site testing, given <b>problems with earlier site studies’ “accuracy.” </b>
              Contrary to this recommendation, the developer relies on old site studies, most of which
              either (a) do not meet US EPA data-validation (anti-fraud) requirements, (b) were done
              by companies fined nearly $1 billion for fraud in other toxic-site testing, or (c) or cannot
              be replicated.
            </li>
            <li>
              <p>
                In a <b>March 19, 2019 email</b>, CA DTSC admitted that the developer will not do a
                Remedial Action Plan (RAP), and instead would do only a Removal Action Workplan
                (RAW). (A RAP requires much more site testing, cleanup, groundwater protection,
                notification of affected agencies and groups, and public participation than is now being
                done under the RAW.) Yet based on the developer’s promises, <b>city officials promised </b>
                (at the July 9, 2018 Council meeting) that a Remedial Action Plan would be done.
              </p>
              <p>
                DTSC said the developer did not need to do the more stringent RAP because it is
                required only for cleanup projects costing “over $2 million. This removal project
                is…$1.913 million, hence only a RAW is required.” However, the developer’s listing of
                cleanup costs in the RAW, <b>released on March 8, 2019</b>, shows that soil-vapor extraction
                may be needed onsite, because “after removal of…hot spots...it is unknown if
                [carcinogenic] VOCs in soil gases will continue to present a…concern,” and soil-vapor
                extraction could raise cleanup costs to “<b>$2,221,600</b>.”
              </p>
              <p>
                Because of this $2,221,600 admission by the developer, a RAP appears required. In
                other words, the developer seems to have <b>artificially lowered his cleanup costs</b> by
                excluding soil-vapor extraction and a vapor mitigation system (both of which he admitted
                may be needed), and then claimed total cleanup costs were only “$1,913,397.”
              </p>
            </li>
          </ol>
        </div>
      </div>
    </div>
    </div>

  </section>
)

export default SiteComponent
